module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA7SURBVHgBRYtLDQAgDEPbKUAC0rCAAxwgcZMwB6MJIbxDP4dHdx8kN4BUL0aE63Rc0hQNn7SqmhrxlANZQxBZM/mxrwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/inactiveDot.png
// module id = 1789
// module chunks = 0